import { fromDateStr, toDateStr } from '../../../../helpers/utcDate';
import { dateRangeShutdownsEnum } from '../constants/dateRangeShutdownsEnum';

export const buildShutdownsUrl = (filters) => {
  const {
    companyId,
    typeId,
    reasonId,
    dateRange,
    dateRangeField,
    streetId,
    houseId,
    addressIds,
    onlyActive,
    initiatorIds,
    executorIds,
    createWorkerId,
    cityId,
    isPlaying,
    forEdds,
    searchValue,
    newShutdown,
  } = filters;

  let url = `/Alert`;
  const params = new URLSearchParams();

  if (!!newShutdown) {
    params.append('alertId', newShutdown);
  } else if (!!searchValue) {
    params.append('alertId', searchValue);
  } else {
    if (dateRangeField === dateRangeShutdownsEnum.CREATE) {
      params.append('createDateFrom', fromDateStr(dateRange[0]));
      params.append('createDateTo', toDateStr(dateRange[1]));
    }

    if (dateRangeField === dateRangeShutdownsEnum.START) {
      params.append('startDateFrom', fromDateStr(dateRange[0]));
      params.append('startDateTo', toDateStr(dateRange[1]));
    }

    if (dateRangeField === dateRangeShutdownsEnum.COMPLETION_PLANNED) {
      params.append('planEndDateFrom', fromDateStr(dateRange[0]));
      params.append('planEndDateTo', toDateStr(dateRange[1]));
    }

    if (dateRangeField === dateRangeShutdownsEnum.COMPLETION_ACTUAL) {
      params.append('endDateFrom', fromDateStr(dateRange[0]));
      params.append('endDateTo', toDateStr(dateRange[1]));
    }

    if (createWorkerId) params.append('createWorkerId', createWorkerId);
    if (companyId) params.append('companiesIds', companyId);
    if (typeId) params.append('alertTypeId', typeId);
    if (reasonId) params.append('alertReasonId', reasonId);
    if (streetId) params.append('streets', streetId);
    if (houseId) params.append('houses', houseId);
    if (addressIds?.length) params.append('addresses', addressIds.join(','));
    if (initiatorIds?.length)
      params.append('initiatorIds', initiatorIds.join(','));
    if (executorIds?.length)
      params.append('executorIds', executorIds.join(','));
    if (isPlaying === true || isPlaying === false)
      params.append('isPlaying', isPlaying);
    if (forEdds === true || forEdds === false)
      params.append('forEdds', forEdds);
    if (cityId) params.append('cityId', cityId);

    params.append('onlyActive', onlyActive);
  }

  const query = params.toString();
  return query ? `${url}?${query}` : url;
};
